import {
  Routes as ReactRouterRoutes,
  Route,
  useNavigate,
} from 'react-router-dom';

import {
  Cnpj,
  NetworkError,
  ResponseError,
  CreationDenied,
  GenericError,
  LinkError,
  RepresentantRegister,
  RepresentantSendingDocuments,
  TranshipmentWelcome,
  TranshipmentDocumentType,
  TranshipmentDocumentsCaptured,
  TranshipmentIdentity,
  PasswordCreation,
  RepresentativePersonalDataCompletionForm,
  TranshipmentGuarantorMaritalStatus,
  TranshipmentSpouseData,
  TranshipmentSendDocumentsAndSelfie,
  TranshipmentSuccess,
  TranshipmentSelfie,
  TranshipmentCnh,
  TranshipmentSpousePersonalDataCompletionForm,
  TokenCode,
  AccountCreated,
} from '~containers';
import {
  Layout,
  ChromeOnIOSGuard,
  TransshipmentDesktopGuard,
} from '~components';

import OnboardingContext from '~contexts/OnboardingContext';
import TranshipmentContext from '~contexts/TranshipmentContext';

import ScreenCPF from '~containers/tokenValidation/ScreenCPF';
import Credit from '~containers/credit';

export let navigate;

function Routes() {
  navigate = useNavigate();

  window.addEventListener('offline', () => {
    navigate('/erro/internet');
  });

  return (
    <ReactRouterRoutes>
      <Route
        index
        element={
          <Layout withRightBanner>
            <Cnpj />
          </Layout>
        }
      />

      <Route
        path="onboarding-nca/:uuid"
        element={
          <Layout withRightBanner>
            <Cnpj />
          </Layout>
        }
      />

      <Route path="representantes">
        <Route element={<Layout withLeftTracking />}>
          <Route path="cadastrar" element={<RepresentantRegister />} />
          <Route
            path="envio-de-documentos-e-selfie"
            element={<TranshipmentSendDocumentsAndSelfie />}
          />
        </Route>

        <Route element={<OnboardingContext />}>
          <Route element={<Layout withLeftTracking />}>
            <Route
              path="analise-de-documentos"
              element={<RepresentantSendingDocuments />}
            />
            <Route path="conta-criada" element={<AccountCreated />} />
          </Route>
        </Route>
      </Route>

      <Route path="entrar" element={<Layout withRightBanner />}>
        <Route path="cpf" element={<ScreenCPF />} />
        <Route path="token" element={<TokenCode />} />
      </Route>

      <Route element={<Layout />}>
        <Route path="*" element={<GenericError />} />

        <Route element={<TransshipmentDesktopGuard />}>
          <Route element={<ChromeOnIOSGuard />}>
            <Route path="transbordo" element={<TranshipmentContext />}>
              <Route index element={<h1>carregando..</h1>} />
              <Route
                path="dados-pessoais"
                element={<RepresentativePersonalDataCompletionForm />}
              />
              <Route
                path="bem-vindo/representante"
                element={<TranshipmentWelcome />}
              />
              <Route
                path="bem-vindo/conjuge"
                element={<TranshipmentWelcome />}
              />
              <Route path="avalista">
                <Route
                  path="dados-do-conjuge"
                  element={<TranshipmentSpouseData />}
                />
                <Route
                  path="conjuge"
                  element={<TranshipmentSpousePersonalDataCompletionForm />}
                />
                <Route
                  path="estado-civil"
                  element={<TranshipmentGuarantorMaritalStatus />}
                />
              </Route>
              <Route path="documentos">
                <Route path="tipo" element={<TranshipmentDocumentType />} />

                <Route
                  path="frente-identidade"
                  element={<TranshipmentIdentity />}
                />

                <Route path="cnh" element={<TranshipmentCnh />} />

                <Route path="selfie" element={<TranshipmentSelfie />} />

                <Route
                  path="sucesso"
                  element={<TranshipmentDocumentsCaptured />}
                />
              </Route>

              <Route path="senha-acesso" element={<PasswordCreation />} />
              <Route path="sucesso" element={<TranshipmentSuccess />} />
            </Route>
          </Route>
        </Route>

        <Route path="erro">
          <Route path="internet" element={<NetworkError />} />
          <Route path="envio-dados" element={<ResponseError />} />
          <Route path="link" element={<LinkError />} />
        </Route>

        <Route path="status">
          <Route path="conta-negada" element={<CreationDenied />} />
        </Route>
      </Route>

      <Route path="credito" element={<Credit />} />
    </ReactRouterRoutes>
  );
}

export default Routes;
